import { Component, h, Prop } from '@stencil/core';

/**
 * @slot media - <me-picture aspectRatio="1.95 / 1">
 * @slot heading - {required}, <me-heading variant=["4", "5"]> -
 *   IMPORTANT: If prop `variant='1'` - set `me-heading variant='4'`; if prop `variant='2'` - set `me-heading variant='5'`
 * @slot description - {required}, <me-text>
 * @slot actions - {required}, <me-button variant="ghost" icon="arrows--chevron-right" iconPosition="after">
 */

@Component({
  tag: 'features-card-type-4',
  styleUrl: 'index.scss',
  shadow: false,
})
export class FeaturesCardType4 {
  /**
   * Card visual variant: '1' (default) or '2', '3'.
   */
  @Prop() variant: 'default' | 'dark' = 'default';

  render() {
    const variantClass = `features-card-type-4--variant-${this.variant}`;
    return (
      <div class={`features-card-type-4 ${variantClass}`}>
        <div class="features-card__info">
          <slot name="heading"></slot>
          <slot name="description"></slot>
          <slot name="actions"></slot>
        </div>
        <div class="features-card__image">
          <slot name="media"></slot>
        </div>
      </div>
    );
  }
}
